<mat-form-field
  [ngStyle]="ngStyle()"
  [attr.id]="field().id"
  [floatLabel]="floatLabel()"
  [appearance]="appearance()"
  [subscriptSizing]="subscriptSizing()"
>
  <mat-label>{{ label() }}</mat-label>
  <mat-date-range-input [rangePicker]="picker" [min]="min()" [max]="max()">
    <input
      matStartDate
      [id]="field().id"
      [formControl]="field().control"
      [placeholder]="field().label"
      (dateInput)="setValueAsISOString('von', $event.value)"
    />
    <input
      matEndDate
      [id]="bisDatumField().id"
      [formControl]="bisDatumField().control"
      [placeholder]="bisDatumField().label"
      (dateInput)="setValueAsISOString('bis', $event.value)"
    />
  </mat-date-range-input>
  <mat-datepicker-toggle matIconSuffix [for]="picker" />
  <mat-date-range-picker #picker />

  @if (showError() && field().control.hasError('matStartDateInvalid')) {
    <mat-error>Ungültiges Von Datum</mat-error>
  }
  @if (showError() && bisDatumField().control.hasError('matEndDateInvalid')) {
    <mat-error>Ungültiges Bis Datum</mat-error>
  }
</mat-form-field>
